<template>
    <div class="text-center">
        <v-dialog v-model="recordDialog" width="35%">
            <v-card>
                <v-card-title
                    class="headline red lighten-2"
                    primary-title>
                    <span style="color: white">GET RECORD</span>
                </v-card-title>
                <v-card-text>
                    <p class="mt-10 modal-label">Get the Following Record by Source ID</p>

                    <v-text-field v-if="!targetFields || targetFields.length == 0" v-model="sourceId" label="Source ID*" required></v-text-field>
                    <template v-if="targetFields && targetFields.length > 0">
                        <v-text-field
                            v-for="(field, index) in targetFields"
                            :key="'field-' + index"
                            :label="field"
                            v-model="sourceIds[index]"
                            @keyup="onFieldChange(index, $event)">
                        </v-text-field>
                    </template>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        small
                        @click="$emit('getRecordModalClose')">
                        Cancel
                    </v-btn>
                    <v-btn
                        small
                        color="primary"
                        @click="onRunSync"
                        :disabled="runDisabled || isProcessing">
                        <span v-if="isProcessing">
                            <v-progress-circular
                                    indeterminate
                                    size="12"
                                    width="2"
                                    color="error darken-3">
                            </v-progress-circular>
                            Processing..
                        </span>
                        <span v-else>Run Sync</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { EventBus } from '../../../event-bus.js'

    export default {
        props: {
          integration: {
             type: Number
          },
          targetFields: {
              type: Array,
              default: null
          }
        },

        computed: {
            runDisabled() {
                return this.sourceId.length === 0 &&
                    this.sourceIds.filter(s => s && s !== '').length === 0 ;
            }
        },

        data : function() {
            return {
                isProcessing: false,
                recordDialog: true,
                sourceId: '',
                sourceIds: []
            }
        },

        mounted() {
            if (this.targetFields && this.targetFields.length > 0) {
                this.targetFields.forEach(ms => {
                    this.sourceIds.push('');
                });
            }
        },

        watch: {
            recordDialog(value, oldValue) {
                if (value != oldValue) {
                    this.$emit('getRecordModalClose')
                }
            },
        },

        methods: {
            onRunSync() {
                if (this.isProcessing) {
                    return
                }

                let data = {
                    'integration_id': this.integration,
                    'source_id': this.sourceId
                };

                if (this.targetFields.length > 0) {
                    let index = this.sourceIds.findIndex(si=> si && si != '');
                    data = {
                        ...data,
                        source_id: this.sourceIds[index],
                        field: this.targetFields[index]
                    }
                }

                this.isProcessing = true
                this.$http.post('/api/sync/id', data)
                    .then( data => {
                        this.isProcessing = false
                        this.$emit('getRecordModalClose');
                        EventBus.$emit('show-success', 'Successfully run the sync.');
                    })
                    .catch( err => {
                        this.$emit('getRecordModalClose');
                        EventBus.$emit('show-error', err);
                        this.isProcessing = false
                    })
            },

            onFieldChange(index, event) {
                this.sourceIds = this.sourceIds.map(_ => '');
                this.sourceIds[index] = event.target.value;
            }
        },
    }
</script>

<style scoped>

    .modal-label {
        font-size: large;
        font-weight: normal;
    }

</style>
